import { render, staticRenderFns } from "./audioToLire.vue?vue&type=template&id=c9150910&scoped=true&lang=pug&"
import script from "./audioToLire.vue?vue&type=script&lang=js&"
export * from "./audioToLire.vue?vue&type=script&lang=js&"
import style0 from "./audioToLire.vue?vue&type=style&index=0&id=c9150910&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9150910",
  null
  
)

export default component.exports